var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.57023 28.1771L6.56928 28.1799C5.38785 31.673 4.79337 35.0487 4.79337 38.3047V47.4126C4.79337 48.7934 5.91265 49.9126 7.29337 49.9126H18.5622C19.9429 49.9126 21.0622 48.7934 21.0622 47.4126L21.0622 38.1957L21.0622 38.1916C21.0273 34.0376 21.6897 30.255 23.0414 26.8372C24.2029 23.9445 25.5931 21.1503 27.2122 18.4547C27.9071 17.2975 27.6031 15.7752 26.4626 15.0152L20.4359 10.9993C19.5207 10.3894 18.2913 10.438 17.458 11.1977C15.2871 13.1771 13.3031 15.5145 11.5047 18.2068L11.504 18.2078C9.43066 21.3285 7.78586 24.6519 6.57023 28.1771ZM33.4498 28.1771L33.4489 28.1799C32.2674 31.673 31.6729 35.0487 31.6729 38.3047V47.4126C31.6729 48.7934 32.7922 49.9126 34.1729 49.9126H45.4418C46.8225 49.9126 47.9418 48.7934 47.9418 47.4126L47.9418 38.1957L47.9418 38.1916C47.9069 34.0378 48.5692 30.2553 49.9208 26.8377C51.0823 23.9447 52.4726 21.1505 54.0917 18.4547C54.7867 17.2975 54.4827 15.7752 53.3422 15.0152L47.3155 10.9993C46.4003 10.3894 45.1708 10.438 44.3376 11.1977C42.1667 13.1771 40.1826 15.5145 38.3843 18.2068L38.3836 18.2078C36.3102 21.3285 34.6654 24.6519 33.4498 28.1771Z",
    fill: "#006633",
    stroke: "#006633"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.00f51b77adf2a973e14c3401d2fdf08a.svg";
export { ForwardRef as ReactComponent };